import { getMonthDates } from "../../utility/CommonFunctions";

export const MainFilterHandler = (pageDetail, talentType) => {
  let filter = [];
  if (pageDetail?.currentPage) {
    filter.push(
      `pageNumber=${pageDetail?.currentPage}&pageSize=${pageDetail?.pageSize}`,
    );
  }
  if (pageDetail?.searchQuery) {
    filter.push(`search=${pageDetail?.searchQuery}`);
  }
  if (pageDetail?.vendorId) {
    filter.push(`vendorId=${pageDetail?.vendorId}`);
  }
  if (pageDetail?.paymentStatus) {
    filter.push(`paymentStatus=${pageDetail?.paymentStatus}`);
  }
  if (pageDetail?.leaveType) {
    filter.push(`leaveType=${pageDetail?.leaveType}`);
  }
  if (pageDetail?.sortByDate?.length > 0) {
    filter.push(
      `startDate=${pageDetail?.sortByDate[0]}&endDate=${pageDetail?.sortByDate[1]}`,
    );
  }
  if (pageDetail?.months?.length > 0) {
    filter.push(
      `startDate=${pageDetail?.months[0]}&endDate=${pageDetail?.months[1]}`,
    );
  }
  if (pageDetail?.sortBySingleDate?.length > 0) {
    filter.push(
      `startDate=${pageDetail?.sortBySingleDate[0]}&endDate=${pageDetail?.sortBySingleDate[0]}`,
    );
  }
  if (pageDetail?.month) {
    filter.push(
      `startDate=${getMonthDates(pageDetail?.month).startDate}&endDate=${getMonthDates(pageDetail?.month).endDate
      }`,
    );
  }
  if (pageDetail?.startDate) {
    filter.push(
      `startDate=${pageDetail?.startDate}&endDate=${pageDetail?.endDate}`,
    );
  }
  if (pageDetail?.staffType) {
    filter.push(`type=${pageDetail?.staffType}`);
  }
  if (pageDetail?.myAttendance) {
    filter.push(`myAttendance=${pageDetail?.myAttendance}`);
  }
  if (pageDetail?.myLeave) {
    filter.push(`myLeave=${pageDetail?.myLeave}`);
  }
  if (pageDetail?.myArrequest) {
    filter.push(`myArrequest=${pageDetail?.myArrequest}`);
  }
  if (pageDetail?.myOdrequest) {
    filter.push(`myOdrequest=${pageDetail?.myOdrequest}`);
  }
  if (pageDetail?.empType) {
    filter.push(`type=${pageDetail?.empType}`);
  }
  if (pageDetail?.type) {
    filter.push(`type=${pageDetail?.type}`);
  }
  if (pageDetail?.stockStatus) {
    filter.push(`stockStatus=${pageDetail?.stockStatus}`);
  }
  if (pageDetail?.requestType) {
    filter.push(`type=${pageDetail?.requestType}`);
  }
  if (pageDetail?.attendanceType) {
    filter.push(`attendanceType=${pageDetail?.attendanceType}`);
  }
  if (pageDetail?.attendanceStatus) {
    filter.push(`status=${pageDetail?.attendanceStatus}`);
  }
  if (pageDetail?.siteId) {
    filter.push(`siteId=${pageDetail?.siteId}`);
  }
  if (pageDetail?.usersId) {
    filter.push(`userId=${pageDetail?.usersId}`);
  }
  if (pageDetail?.officeType) {
    filter.push(`officeId=${pageDetail?.officeType}`);
  }
  if (pageDetail?.leaveStatus) {
    filter.push(`status=${pageDetail?.leaveStatus}`);
  }
  if (pageDetail?.aRStatus) {
    filter.push(`status=${pageDetail?.aRStatus}`);
  }
  if (pageDetail?.oDStatus) {
    filter.push(`status=${pageDetail?.oDStatus}`);
  }
  if (pageDetail?.department) {
    filter.push(`departmentId=${pageDetail?.department}`);
  }
  if (pageDetail?.designation) {
    filter.push(`designationId=${pageDetail?.designation}`);
  }
  if (pageDetail?.user) {
    filter.push(`teamUserId=${pageDetail?.user}`);
  }
  if (pageDetail?.orderBy) {
    filter.push(`orderBy=${pageDetail?.orderBy}`);
  }
  if (pageDetail?.status !== undefined && pageDetail?.status !== null && pageDetail?.status !== "") {
    filter.push(`status=${pageDetail?.status}`);
  }
  // if (pageDetail?.empStatus) {
  //     filter.push(`status=${pageDetail?.empStatus}`)
  // }
  if (pageDetail?.year) {
    filter.push(`year=${pageDetail?.year}`);
  }
  if (pageDetail?.companyId) {
    filter.push(`companyId=${pageDetail?.companyId}`);
  }
  if (pageDetail?.expenseHeadId) {
    filter.push(`expenseHeadId=${pageDetail?.expenseHeadId}`);
  }
  if (pageDetail?.createdById) {
    filter.push(`creatorId=${pageDetail?.createdById}`);
  }
  if (pageDetail?.tdsType) {
    filter.push(`tdsType=${pageDetail?.tdsType}`);
  }
  if (pageDetail?.dueDay) {
    filter.push(`dueDay=${pageDetail?.dueDay}`);
  }
  if (pageDetail?.due) {
    filter.push(`due=${pageDetail?.due}`);
  }
  if (pageDetail?.advisorytype) {
    filter.push(`advisorytype=${pageDetail?.advisorytype}`);
  }
  if (pageDetail?.exportDataType) {
    filter.push(`exportDataType=${pageDetail?.exportDataType}`);
  }
  if (pageDetail?.customerId) {
    filter.push(`customerId=${pageDetail?.customerId}`);
  }
  if (pageDetail?.customerCompanyId) {
    filter.push(`customerCompanyId=${pageDetail?.customerCompanyId}`);
  }
  if (pageDetail?.userType == 0 || pageDetail?.userType) {
    filter.push(`userType=${pageDetail?.userType}`);
  }
  if (pageDetail?.selectedMonths && pageDetail?.selectedMonths.length > 0) {
    const months = pageDetail.selectedMonths.map((m) => m.id).join(",");
    filter.push(`month=${months}`);
  }
  if (pageDetail?.salaryMonth) {
    filter.push(`month=${pageDetail?.salaryMonth}`);
  }
  if (pageDetail?.financialYear) {
    filter.push(`financialYear=${pageDetail?.financialYear}`);
  }
  if (pageDetail?.includeExpenseMonth && pageDetail?.expenseMonth) {
    filter.push(`expenseMonth=${pageDetail?.expenseMonth}`);
  }
  if (pageDetail?.isInvoice !== undefined && pageDetail?.isInvoice !== null && pageDetail?.isInvoice !== "") {
    filter.push(`isInvoice=${pageDetail?.isInvoice}`);
  }

  let filterData = filter.join("&");
  return filterData;
};
